import { Button } from '@ytl/common-web';
import { useCallback, useState } from 'react';
import { useOpenAm } from '../contexts/openAmContext';
import { useOpenAmStage } from '../shared/services/useOpenAmStage';

export const MockTestLoginStage = () => {
  const { isLoading } = useOpenAm();
  const [error, setError] = useState('');
  const { continueTestLogin } = useOpenAmStage();

  const handleLogin = useCallback(async () => {
    try {
      await continueTestLogin(_failure => {
        setError('Login failed');
      });
    } catch (err) {
      setError('An error occurred');
    }
  }, [continueTestLogin]);

  return (
    <>
      <h3>Test Login</h3>

      {error && <div className="login-page__container__error">{error}</div>}

      <Button
        variant={'contained'}
        onClick={handleLogin}
        disabled={isLoading}
      >
        Login as testuser
      </Button>
    </>
  );
};
